export default __webpack_public_path__ + "static/media/Funnel.7ccb91c8.svg";